
import PrimaryButton from '@/components/ui/primaryButton.vue';
import Field from '@/components/ui/field.vue';

export default {
  name: 'SignUp',

  components: {
    Field,
    PrimaryButton,
  },

  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      confirmPassword: null,
      consent: false,
      error: null,
      emailError: null,
      passwordError: null,
      confirmPasswordError: null,
      consentError: null,
      success: false,
      loading: false,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.password &&
        this.password.length >= 6 &&
        ((this.consent && this.displayConsentCheckbox) ||
          !this.displayConsentCheckbox) &&
        this.password === this.confirmPassword &&
        !this.emailError &&
        !this.passwordError &&
        !this.confirmPasswordError &&
        !this.consentError
      );
    },
  },

  methods: {
    displayConsentCheckbox() {
      return this.isPortuguese || this.isSpanish;
    },

    validateLength() {
      if (this.password.length < 6) {
        this.passwordError = this.$t('forms.shortPasswordError');
      } else {
        this.passwordError = null;
      }
    },

    validatePasswords() {
      if (this.password !== this.confirmPassword) {
        this.confirmPasswordError = this.$t('forms.noMatchPassword');
      } else {
        this.confirmPasswordError = null;
      }
    },

    validateEmail() {
      const reg = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!reg.test(this.email)) {
        this.emailError = this.$t('forms.invalidMail');
      } else {
        this.emailError = '';
      }
    },

    validateConsent() {
      if (this.displayConsentCheckbox && !this.consent) {
        this.consentError = this.$t('forms.consentError');
      } else {
        this.consentError = '';
      }
    },

    async submit() {
      if (this.canSubmit) {
        this.loading = true;
        try {
          this.loading = true;
          const response = await this.$bolev.createUser({
            email: this.email,
            first_name: this.firstName,
            last_name: this.lastName,
            password: this.password,
          });
          if (response.data.success) {
            this.$router.push('/login');
          } else if (
            (response.data.message === 'patient_exists',
            response.data.message === 'user_exists',
            response.data.message === 'client_exists')
          ) {
            this.error = this.$t('login.userExists');
          } else {
            this.error = this.$t('global.somethingWentWrong');
          }
          this.loading = false;
        } catch (error) {
          this.error = this.$t('global.somethingWentWrong');
          this.loading = false;
        }
      } else {
        this.error = this.$t('global.somethingWentWrong');
      }
    },
  },
};
